module.exports = flarum.core.compat['models/User'];